var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24a3.01 3.01 0 0 0 3 3h12a3.01 3.01 0 0 0 3-3V7.3h-18ZM21 1.5h-5.25L14.25 0h-7.5l-1.5 1.5H0v3h21Z",
    "data-name": "Icon material-delete"
  })));
};
export default SvgDelete;